module.exports = __webpack_public_path__ + "static/pemalex_logo_clientes_fille-2efa81bb7c41897259b374534b88da08.png";